import { useState, Link, Icon, Toast, useForm, useNavigate, useUser, useEffect } from "../utils/commonImports";
import { _api } from '../auth/Api';

const SignInPage = () => {
  const navigate = useNavigate();
  const { loginUser } = useUser();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [blockUser, setBlockUser] = useState(false)

  // useEffect(() => {
  //   const isBlocked = localStorage.getItem("x_t61068")
  //   if (isBlocked) {
  //     setBlockUser(true)
  //   } else {
  //     setBlockUser(false)
  //   }
  // }, [])

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = async (data) => {
    try {
      setLoading(true);
      await _api("POST", "PortalUser/PortalUserLogin", data, function (res) {
        if (res && res?.loginUser?.isSuccess) {
          let x_e = { t: res.loginUser.token, ed: res.loginUser.expiryDate, et: res.loginUser.expiryTime };
          loginUser(res.loginUser);
          localStorage.setItem('x_t', JSON.stringify(x_e));
          Toast.fire({ icon: 'success', title: "Logged in successfully" });
          setTimeout(() => {
            navigate('/');
          }, 2000);
        } else if (res.isError && res.message === "Your account has been blocked, Please contact Admin.") {
          // localStorage.setItem("x_t61068", JSON.stringify(res?.message))
          setBlockUser(true)
          setLoading(false);
        } else {
          Toast.fire({ icon: 'error', title: res?.message });
          setLoading(false);
        }
      });
    } catch (error) {
      Toast.fire({ icon: 'error', title: "Something went wrong" });
      setLoading(false);
    } finally {
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center min-vh-100"
      style={{
        backgroundImage: `url('assets/images/changan-bg/oshan.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div
        className="bg-white rounded-lg shadow-lg p-5 w-100 max-w-md SignInMobile"
        style={{ maxWidth: "500px" }}
      >
        <div className="text-center mb-4">
          <img className="mb-3" src="assets/images/changan-logo/logo-with-text.png" alt="Logo" style={{ width: "50%" }} />
          {!blockUser && <p className="text-secondary-light text-sm">Welcome back! Please enter your email address and password to access admin panel.</p>}
        </div>
        {blockUser ? (
          <div>
            <div className="alert alert-danger d-flex align-items-center justify-content-center gap-2 p-4" role="alert" style={{ borderRadius: "8px" }}>
              <Icon icon="mdi:account-cancel" style={{ fontSize: "24px", color: "#842029" }} />
              <span className="" style={{ fontSize: "16px", color: "#842029" }}>Account Blocked</span>
            </div>
            <p className="mb-2 text-center text-secondary-light text-sm">
              Your account has been <strong>blocked</strong> due multiple invalid attempts.
            </p>
            <p className="text-center text-secondary-light text-sm"> Please contact the <strong>Administrator</strong> to regain access.</p>
            <button type="button" className="btn btn-primary text-sm btn-sm px-12 py-10 w-100 radius-5 mt-4"  onClick={() => setBlockUser(false)}>
            Try With Another User
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit(handleLogin)}>
            {/* <span className="text-sm text-secondary-light mb-2">Email Address</span> */}
            <div className="mb-3">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y"> <Icon icon="mage:email" /> </span>
                <input
                  type="email"
                  {...register("userEmail", { required: "Email is required" })}
                  className="form-control h-45-px bg-neutral-50 radius-5"
                  placeholder="Enter your email"
                />
              </div>
              {errors.userEmail && <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">{errors.userEmail.message}</span>}
            </div>
            {/* <span className="text-sm text-secondary-light mb-2">Password</span> */}
            <div className="mb-2 position-relative">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  {...register("password", { required: "Password is required" })}
                  className="form-control h-45-px bg-neutral-50 radius-5 pe-40"
                  placeholder="Enter your password"
                />
                <span
                  onClick={togglePassword}
                  className="position-absolute top-50 translate-middle-y end-0 me-3 cursor-pointer text-muted"
                  style={{ fontSize: "1.2rem" }}
                >
                  <Icon icon={showPassword ? "mdi:eye-off-outline" : "mdi:eye-outline"} style={{ verticalAlign: "middle", color: "#848181" }} />
                </span>
              </div>
              {errors.password && <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">{errors.password.message}</span>}
            </div>

            <div className="d-flex justify-content-between mb-3" style={{ marginTop: "10px" }}>
              <div className="form-check style-check d-flex align-items-center">
                <input className="form-check-input border border-neutral-300" type="checkbox" id="remember" />
                <label className="form-check-label text-sm" htmlFor="remember"> Remember me </label>
              </div>
              <Link to="/forgot-password" className="text-primary-600 text-sm"> Forgot Password? </Link>
            </div>

            <button type="submit" className="btn btn-primary text-sm btn-sm px-12 py-10 w-100 radius-5 mt-4" disabled={loading}>
              {loading ? (<>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> Signing In...
              </>) : (
                "Sign In"
              )}
            </button>

            {/* <div className="mt-3 text-center text-sm">
            <p className="mb-0">
              Don’t have an account?{" "}
              <Link to="/sign-up" className="text-primary-600"> Sign Up</Link>
            </p>
          </div> */}
          </form>
        )}

      </div>
    </div>
  );
};

export default SignInPage;
